<router-outlet></router-outlet>
<uni-loader *ngIf="isLoaderActive$ | async" [isFullScreen]="true"></uni-loader>